module.exports = __webpack_public_path__ + "static/media/atomize_logo.9b92d9be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/atomize_logo.png
// module id = 471
// module chunks = 0